import React from 'react';
import { LivenessQuickStartReact } from './Liveness/LivenessQuickStartReact';

function App() {
  return (
    <div>
      <LivenessQuickStartReact />
    </div>
  );
}

export default App;
